import * as Yup from 'yup';

export const password = Yup.string()
  .required('Password is required')
  .min(8, 'Password must be at least 8 characters')
  .matches(/[0-9]+/g, 'Password must contain numbers')
  .matches(/[a-z]+/g, 'Password must contain letters')
  .matches(/[A-Z]+/g, 'Password must contain uppercase letters')
  .matches(
    /[~`$&,:;?@#/\\{}_|'<>[\].^*()%!"]+/g,
    'Password must contain special characters',
  );
